export enum BetPlacementStatus{
    NotStarted = 0,
    InProcess = 1,
    Error = 2,
    Success = 3
}